import { Enums } from '@bode-canada/core';
import { QueryParams } from '@/constants/QueryParams';
import { ComparableBuildingTypeMap } from '@/components/shared/comparable/constants';

// eslint-disable-next-line import/prefer-default-export
export class FiltersCreateHelper {
  static getFilterValues(allowedProperties, filter) {
    if (filter === Enums.BuildingClassEnum.VACANT_LAND) {
      return [Enums.BuildingClassEnum.VACANT_LAND];
    }

    return allowedProperties.includes(filter)
      ? this.#getFiltersWithFirstSearchCriteria(filter, allowedProperties)
      : null;
  }

  static #getFiltersWithFirstSearchCriteria(filter, allowedProperties) {
    return [
      filter,
      ...allowedProperties.filter((value) => value !== filter),
    ];
  }

  static getCommonComparableQueries(listing) {
    return {
      [QueryParams.Parking]: listing.totalParking || 0,
      [QueryParams.Style]: listing.style,
      [QueryParams.MinYearBuilt]: listing.yearBuilt,
      [QueryParams.Beds]: listing.beds,
      [QueryParams.Baths]: listing.fullBaths,
      [QueryParams.MinFinishedSqft]: listing.finishedSqft || listing.lotSizeSqft,
    };
  }

  static getComparableRequestQueries(listing) {
    const {
      location: [lon, lat],
      buildingClass,
      buildingType,
      yearBuilt,
    } = listing;
    const finishedArea = listing.finishedSqft || listing.lotSizeSqft;

    return {
      ...FiltersCreateHelper.getCommonComparableQueries(listing),
      [QueryParams.Lat]: lat,
      [QueryParams.Lng]: lon,
      [QueryParams.BuildingType]: ComparableBuildingTypeMap[buildingType] || buildingType,
      [QueryParams.BuildingClass]: ComparableBuildingTypeMap[buildingClass] || buildingClass,
      [QueryParams.YearBuilt]: {
        min: yearBuilt || 0,
      },
      [QueryParams.FinishedArea]: {
        min: finishedArea || 0,
      },
    };
  }

  static getListingComparableFilters(listing) {
    return {
      listingId: listing.listingId,
      country: listing.country,
      state: listing.province,
      city: listing.city,
      community: listing.community,
      street: listing.street,
      streetNumber: listing.streetNumber,
      unit: listing.unit,
    };
  }
}
